var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.355 5.9c-1.05 -1.15 -2.95 -1.5 -4.25 -0.5 -1.9 1.45 -1.7 5.15 0.3 7.55 1 1.2 2.3 1.95 3.3 1.5 0.4 -0.2 0.9 -0.2 1.3 0 1 0.45 2.3 -0.3 3.3 -1.5 2 -2.4 2.2 -6.1 0.3 -7.55 -1.3 -1 -3.2 -0.65 -4.25 0.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.355 5.9V3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.355 4.3c1.05 -1.35 2.6 -1.55 3.45 -1.4 0.15 1.05 -0.3 2.45 -1.6 2.95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.8098070ff4283b66ffc3f7298503aeee.svg";
export { ForwardRef as ReactComponent };